module.exports = __webpack_public_path__ + "img/1534531516.bf6f5c98.jpg";